import { get, writable } from "svelte/store";
import { sendSocketMessage } from "./socketStore";
import { roomStore } from "./roomStore";
export const localVideoStore = writable(null);
export const localMediaState = writable({
    videoPaused: false,
    videoPauseOrigin: null,
    audioMuted: false,
    audioMuteOrigin: null,
});
export function pauseLocalVideoStream() {
    const stream = get(localVideoStore);
    const room = get(roomStore);
    console.log('[resumeLocalVideoStream] stream', stream);
    console.log('[resumeLocalVideoStream] room', room);
    if (!stream || !room)
        return;
    console.log("[localVideoStore] pause local stream");
    stream.getTracks().forEach(track => {
        if (track.kind === "video") {
            track.enabled = false;
        }
    });
    localMediaState.update(s => (Object.assign(Object.assign({}, s), { videoPaused: true, videoPauseOrigin: "self" })));
    sendSocketMessage({
        room: room.id,
        action: "pause",
        type: "video",
    });
}
export function resumeLocalVideoStream() {
    const stream = get(localVideoStore);
    const room = get(roomStore);
    console.log('[resumeLocalVideoStream] stream', stream);
    console.log('[resumeLocalVideoStream] room', room);
    if (!stream || !room)
        return;
    console.log("[localVideoStore] resume local stream");
    stream.getTracks().forEach(track => {
        if (track.kind === "video") {
            track.enabled = true;
        }
    });
    localMediaState.update(s => (Object.assign(Object.assign({}, s), { videoPaused: false, videoPauseOrigin: null })));
    sendSocketMessage({
        room: room.id,
        action: "resume",
        type: "video",
    });
}
export function stopLocalVideoStream() {
    const stream = get(localVideoStore);
    if (!stream)
        return;
    console.log("[localVideoStore] stopping local tracks");
    stream.getTracks().forEach(track => track.stop());
    localVideoStore.set(null);
}
export function getVideoTrack() {
    const stream = get(localVideoStore);
    if (stream && stream.getVideoTracks().length > 0) {
        return stream.getVideoTracks()[0];
    }
    return null;
}
export async function toggleLocalTorch(turnOn) {
    const stream = get(localVideoStore);
    if (!stream)
        return false;
    const track = stream.getVideoTracks()[0];
    if (!track)
        return false;
    try {
        const capabilities = track.getCapabilities();
        if (!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.torch)) {
            console.warn("[torch] not supported");
            return false;
        }
        await track.applyConstraints({
            advanced: [{ torch: turnOn }],
        });
        console.log("[torch] toggled:", turnOn);
        return true;
    }
    catch (err) {
        console.error("[torch] error:", err);
        return false;
    }
}
export function isLocalTorchAvailable() {
    const stream = get(localVideoStore);
    if (!stream)
        return false;
    const track = stream.getVideoTracks()[0];
    if (!track)
        return false;
    const capabilities = track.getCapabilities();
    return !!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.torch);
}
export function pauseLocalVideoStreamFromRemote() {
    const stream = get(localVideoStore);
    if (!stream)
        return;
    console.log("[localVideoStore] pause local stream FROM REMOTE");
    stream.getTracks().forEach(track => {
        if (track.kind === "video") {
            track.enabled = false;
        }
    });
    localMediaState.update(s => (Object.assign(Object.assign({}, s), { videoPaused: true, videoPauseOrigin: "conseiller" })));
}
export function resumeLocalVideoStreamFromRemote() {
    const stream = get(localVideoStore);
    if (!stream)
        return;
    console.log("[localVideoStore] resume local stream FROM REMOTE");
    stream.getTracks().forEach(track => {
        if (track.kind === "video") {
            track.enabled = true;
        }
    });
    localMediaState.update(s => (Object.assign(Object.assign({}, s), { videoPaused: false, videoPauseOrigin: null })));
}
export function muteLocalAudio(origin = "self") {
    const stream = get(localVideoStore);
    const room = get(roomStore);
    if (!stream || !room)
        return;
    stream.getAudioTracks().forEach(track => track.enabled = false);
    localMediaState.update(s => (Object.assign(Object.assign({}, s), { audioMuted: true, audioMuteOrigin: origin })));
    sendSocketMessage({
        room: room.id,
        action: "mute",
        type: "video",
    });
}
export function unmuteLocalAudio(origin = "self") {
    const stream = get(localVideoStore);
    const room = get(roomStore);
    if (!stream || !room)
        return;
    stream.getAudioTracks().forEach(track => track.enabled = true);
    localMediaState.update(s => (Object.assign(Object.assign({}, s), { audioMuted: false, audioMuteOrigin: null })));
    sendSocketMessage({
        room: room.id,
        action: "unmute",
        type: "video",
    });
}
